export const APP_NAME = 'REILoans';
export const HUMAN_APP_NAME = 'REI Loans'
export const EMAIL_FROM = 'credentials@reiloans.com';

export const IS_LENDINGONE = false;
